<template>
  <div>
    <div
      v-if="enableEditClosingDate"
      class="closing-date-wrapper"
    >
      <closing-date
        ref="closingDate"
        :invalidClosingDate="partialClosingDate || invalidClosingDate"
        :invalidContactInfo="invalidContactInfo"
        :highlightflags="highlightflags"
        :invalidVisitDayAndTime="invalidVisitDayAndTime"
        @updated:partial="val => $emit('update:partialClosingDate', val)"
        @update:invalidVisitTimes="val => invalidVisitTimes = val"
      />
    </div>
    <div v-if="readonly && !isWappr && !isAppr">
      <closing-date-view />
    </div>
  </div>
</template>

<script>
import ClosingDate from '@/modules/tenders/edit/ClosingDate'
import ClosingDateView from '@/modules/tenders/view/ClosingDate'

import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import dateUtil from '@/utils/dateUtil'
import { tenderStatus } from '@/utils/locale'
import { dateFormat } from '@/utils/regex'

import { mapGetters } from 'vuex'

export default {
  components: {
    ClosingDate,
    ClosingDateView,
  },

  props: {
    partialClosingDate: Boolean,
  },
  data () {
    return {
      invalidContactInfo: false,
      invalidVisitTimes: [],
      highlightflags: [],
      visitVendorCounter: 0,
    }
  },

  methods: {
    validateOnsiteVisitInfo () {
      fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'})
      const required = this.general.onsiteVisitRequired
      const onsiteLocation = this.general.onsiteLocation
      const onsiteContact = this.general.onsiteContact
      if (required) {
        this.invalidContactInfo = !(onsiteLocation && onsiteContact &&
          !Object.values(onsiteContact).some(value => !value) &&
          fusionInputCheckUtil.isAllFieldsValid())
      } else {
        this.invalidContactInfo = false
      }
    },
    validateVisitTimes () {
      const closingDateTime = this.general.closingDate ? dateUtil.toMoment(this.general.closingDate).valueOf() : 0
      this.$refs.closingDate.validateExistingOnSiteVisitTimes(closingDateTime)
      for (let i = 0; i < this.invalidVisitTimes.length; i += 1) {
        if (this.invalidVisitTimes[i]) {
          return true
        }
      }
      return false
    },
    hasInvalidVisitTime () {
      if (!this.general.onsiteVisitRequired || !this.enableEditClosingDate) return false
      return this.validateVisitTimes()
    },
    validate () {
      this.validateOnsiteVisitInfo()
      if (this.invalidClosingDate || this.invalidContactInfo || this.invalidVisitDayAndTime || this.hasInvalidVisitTime()) {
        return false
      }
      return true
    },
  },

  computed: {
    ...mapGetters('tenders', ['currentTender', 'isAddendum', 'isTender']),
    ...mapGetters('user', {
      currentUser: 'currentUser',
    }),

    general () { return this.currentTender.general || {} },

    isDraft () {
      return this.general.status === tenderStatus.DRAFT
    },
    isAppr () {
      return this.general.status === tenderStatus.APPR
    },
    isWappr () {
      return this.general.status === tenderStatus.WAPPR
    },
    isPicView () {
      return this.currentUser.id === this.currentTender.general.managedBy
    },
    isTmView () {
      return this.currentUser.id === this.general.approvedBy
    },
    readonly () {
      const status = this.general.status || ''
      return status.endsWith(tenderStatus.ISSUED) ||
        status.endsWith(tenderStatus.WAPPR) ||
        status.endsWith(tenderStatus.READY)
    },
    closingDateUpdateRequired () {
      return this.isAddendum && this.general.closingDateExtended
    },
    enableEditClosingDate () {
      return !this.readonly && this.isPicView &&
        (!this.isAddendum || this.closingDateUpdateRequired)
    },
    invalidVisitDayAndTime () {
      let invalid = false
      if (this.general.onsiteVisitRequired) {
        const bids = this.currentTender.bids
        let visitVendorCounter = 0
        for (let i = 0; i < bids.length; i += 1) {
          const visitDate = bids[i].visitDate
          if (visitDate) {
            visitVendorCounter++
            if (this.invalidVisitTimes[i]) {
              invalid = true
              this.highlightflags[i] = true
            } else {
              this.highlightflags[i] = false
            }
          } else {
            this.highlightflags[i] = false
          }
        }
        if (visitVendorCounter <= 0 && this.general.closingDate) {
          invalid = true
          this.highlightflags = new Array(bids.length).fill(true) // eslint-disable-line
        }
      }
      return invalid
    },
    invalidClosingDate () {
      if (!this.general.closingDate) {
        return true
      }

      const setClosingDate = new Date(this.general.closingDate)
      const today = new Date()
      if (this.enableEditClosingDate && setClosingDate.getTime() - today.getTime() <= 0) {
        return true
      }

      const convertedClosingDateTime = dateUtil.convertDateToArray(this.currentTender.general.closingDate, dateFormat, '-')
      const time = convertedClosingDateTime[1].trim()
      return time === '00:00'
    },
  },
}
</script>
